export default {
  loading: {
    id: 'customer_testing_report_page_loading',
    defaultMessage: 'Loading your report…',
  },
  errorTitle: {
    id: 'customer_testing_report_page_error_title',
    defaultMessage: 'Report unavailable',
  },
  errorDescription: {
    id: 'customer_testing_report_page_error_description',
    defaultMessage:
      'We could not load this testing report. Please try again later.',
  },
  retry: {
    id: 'customer_testing_report_page_retry',
    defaultMessage: 'Try again',
  },
}
